/* eslint-disable no-new */
import { throttle } from 'lodash';
import SimpleParallax from 'simple-parallax-js';

export default (function () {
  return {
    init() {
      if(window.innerWidth > 768) {
        window.addEventListener('scroll', throttle(this.parallax, 14));
        window.addEventListener('scroll', throttle(this.fade, 14));
      }
    },

    parallax() {
      const elem = document.querySelectorAll('.js-parallax-image');

      if (elem.length === 0) return;
      elem.forEach((el) => {
        new SimpleParallax(el, {
          delay: 4,
          scale: 1.2,
        });
      });
    },

    fade() {
      const elem = document.querySelectorAll('.js-opacity');
      const scroll = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

      elem.forEach((el) => {
        const top = el.parentElement.parentElement.offsetTop;
        el.style.opacity = Math.max(0, Math.min(1, -scroll / top + 1.6));
      });
    },
  };
})();
